import { ComputedRef } from 'vue'

import { FreeSpaceStateViewModel } from '@/presentation/viewmodels/freeSpace/freeSpaceStateViewModel'

export class FreeSpaceStatePresenter {
  private viewModel: FreeSpaceStateViewModel

  constructor(viewModel: FreeSpaceStateViewModel) {
    this.viewModel = viewModel
  }

  get sourceCode(): ComputedRef<string> {
    return this.viewModel.sourceCode
  }

  get testInput(): ComputedRef<string> {
    return this.viewModel.testInput
  }

  get userOutput(): ComputedRef<string> {
    return this.viewModel.userOutput
  }

  get isErrorShow(): ComputedRef<boolean> {
    return this.viewModel.isErrorShow
  }

  get errorMessage(): ComputedRef<string | null> {
    return this.viewModel.errorMessage
  }

  setSourceCode(code: string): void {
    this.viewModel.setSourceCode(code)
  }

  setTestInput(input: string): void {
    this.viewModel.setTestInput(input)
  }

  setIsErrorShow(isErrorShow: boolean): void {
    this.viewModel.setIsErrorShow(isErrorShow)
  }

  setErrorMessage(message: string): void {
    this.viewModel.setErrorMessage(message)
  }
}
